import { Card, Space, Typography } from "antd";
import React from "react";
import { IConfigProps, ListConfig } from "./components/ListConfig";

type Props = {
	prefixKey?: string;
	title?: string;
	description?: string;
	configs: IConfigProps[];
};
const AppConfig: React.FC = () => {
	const multipleConfigs: Props[] = [
		{
			title: "Dashboard Mobile Quote Setting",
			description: "Manage your dashboard mobile quote setting here",
			configs: [
				{
					key: "DASHBOARD_QUOTE",
					label: "DASHBOARD QUOTE",
					type: "TEXTAREA",
				},
				{
					key: "DASHBOARD_QUOTE2",
					label: "DASHBOARD QUOTE 2",
					type: "TEXTAREA",
				},
				{
					key: "DASHBOARD_QUOTE3",
					label: "DASHBOARD QUOTE 3",
					type: "TEXTAREA",
				},
			],
		},
		{
			title: "HQ Setting",
			description: "Manage your HQ setting here",
			configs: [
				{
					key: "BANK_NAME",
					label: "BANK NAME",
				},
				{
					key: "HQ_FINANCE_NAME",
					label: "HQ FINANCE NAME",
				},
				{
					key: "HQ_EMAIL",
					label: "HQ EMAIL",
				},
				{
					key: "HQ_FINANCE_EMAIL",
					label: "HQ FINANCE EMAIL",
				},
				{
					key: "HQ_FINANCE_WHATSAPP",
					label: "HQ FINANCE WHATSAPP",
				},
				{
					key: "HQ_COMPANY_NAME",
					label: "HQ COMPANY NAME",
				},
				{
					key: "HQ_ADDRESS",
					label: "HQ OFFICE ADDRESS",
				},
				{
					key: "HQ_PHONE",
					label: "HQ OFFICE PHONE",
				},
				{
					key: "HQ_WHATSAPP",
					label: "HQ WHATSAPP PHONE",
				},
				{
					key: "BANK_ACCOUNT_NAME",
					label: "BANK ACCOUNT NAME",
				},
				{
					key: "BANK_ACCOUNT_NUMBER",
					label: "BANK ACCOUNT NUMBER",
				},
			],
		},

		{
			title: "Social Media Setting",
			description: "Manage your social media setting here",
			configs: [
				{
					key: "FACEBOOK_URL",
					label: "FACEBOOK URL",
				},
				{
					key: "TWITTER_URL",
					label: "TWITTER URL",
				},
				{
					key: "INSTAGRAM_URL",
					label: "INSTAGRAM URL",
				},
				{
					key: "YOUTUBE_URL",
					label: "YOUTUBE URL",
				},
				{
					key: "TIKTOK_URL",
					label: "TIKTOK URL",
				},
			],
		},

		{
			title: "Other Setting",
			description: "Manage your other setting here",
			configs: [
				{
					key: "STAR_AGENT_VIDEO_EMBED",
					label: "STAR AGENT VIDEO EMBED",
				},
				{
					key: "ABOUT_US_VIDEO_EMBED",
					label: "ABOUT US VIDEO EMBED",
				},
			],
		},
	];
	return (
		<React.Fragment>
			<Space
				direction="vertical"
				size="middle"
			>
				<Typography.Title level={3}>App Config</Typography.Title>
				<Card
					bordered={false}
					size="small"
				>
					{multipleConfigs.map((config, _) => (
						<div style={{ marginBottom: 20 }}>
							<ListConfig
								{...config}
								title={config.title || "Config"}
								description={config.description || `Manage configuration`}
								configs={config.configs || []}
							/>
						</div>
					))}
				</Card>
			</Space>
		</React.Fragment>
	);
};
export default AppConfig;
